import { EServiceId } from '../../../redux/reducers';

interface IParams {
  serviceId: EServiceId | null;
  currentBet: number;
}

export const getBetPositionText = (params: IParams) => {
  const { serviceId, currentBet } = params;

  switch (serviceId) {
    case EServiceId.top:
      return 'До x5 звонков';

    case EServiceId.premium:
      return 'До x3 звонков';

    default:
      if (currentBet > 0) {
        return 'Выше ставка — больше звонков';
      } else {
        return 'Внизу поиска';
      }
  }
};
